/**
 * Visual parity with the MCP sign-in page
 * (qcomm-blinkit-mcp/src/oauth/routes.ts — GET /authorize), so a user meets the
 * same screen whether they arrive through the MCP or the dashboard.
 */
.page {
  width: 100%;
  min-height: 100vh;
  background: var(--auth-bg-image) no-repeat;
  background-size: cover;
  background-color: #f9fafb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
  padding: 20px 0;
  position: relative;
  font-family: var(--font-family);
}

.card {
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 12px;
  padding: 40px 36px;
  width: 100%;
  max-width: 440px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.title { font-size: 26px; font-weight: 700; color: #1a1a2e; text-align: center; margin: 0 0 8px; }
.subtitle { text-align: center; color: #6b7280; font-size: 14px; margin: 0 0 28px; }

.field { margin-bottom: 20px; }
.label { display: block; font-size: 14px; font-weight: 500; color: #333; margin-bottom: 6px; }
.inputWrap { position: relative; }

.input {
  width: 100%;
  padding: 11px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  color: #1a1a2e;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}
.input:focus { border-color: #6c63ff; box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.1); }

.togglePw {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  padding: 4px;
  display: flex;
  align-items: center;
  width: auto;
}
.togglePw:hover { color: #6b7280; }
.togglePw svg { width: 20px; height: 20px; }

.optionsRow { display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px; }
.forgot { font-size: 14px; color: #6c63ff; text-decoration: none; font-weight: 500; }
.forgot:hover { text-decoration: underline; }

.signIn {
  width: 100%;
  padding: 12px;
  background: #6c63ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s;
}
.signIn:hover:not(:disabled) { background: #5b52e6; }
.signIn:disabled { background: #a5a1f5; cursor: not-allowed; }

.error {
  background: #fef2f2;
  color: #dc2626;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  border: 1px solid #fecaca;
}

.info { color: #9ca3af; font-size: 12px; text-align: center; margin-top: 24px; }
